import React from 'react';
import { ImageRaw } from '../../../../components/image-raw';
import SingerNameText from './singer-name-text';
interface Singer {
  id: number;
  name: string;
  imageUrl: string;
  category: string;
}

interface SingerCardProps {
  singer: Singer;
  variant?: 'medium' | 'small'
}

// Đường dẫn đến các hình ảnh không thay đổi
const images = {
  background: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/optimized/singer-card-background.webp',
  kidsplazaLogo: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/kidsplaza-logo-light.png',
  festivalLogo: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/festival-logo.png',
  vuonConcertLogo: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/optimized/hero-logo.webp',
  singerBackground: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/optimized/singer-background.webp',
};


// Custom style cho tên ca sĩ để tạo hiệu ứng viền
const singerNameStyle = {
  color: 'white',
  WebkitTextStroke: '2px #D052F3', // Viền cho trình duyệt Webkit (Chrome, Safari)
  textStroke: '2px #D052F3',       // Viền tiêu chuẩn
  textShadow: '3px 3px 0px rgba(111, 28, 142, 0.8)', // Đổ bóng để tạo chiều sâu
};

const SingerCard: React.FC<SingerCardProps> = ({ singer, variant = 'medium' }) => {
  return (
    <div
      className="relative w-full max-w-[229px] aspect-[229/390] lg:aspect-[229/390] xl:aspect-[377/520] lg:!max-w-[377px] bg-cover bg-center rounded-[6%] mx-auto"
      style={{
        backgroundImage: `url(${images.background})`,
        minWidth: '229px' // Đảm bảo có width tối thiểu để aspect ratio hoạt động
      }}
    >
      {/* Header */}
      <header className="absolute top-[1%] left-0 right-0 z-20 flex items-center justify-between px-[4%] sm:px-[6%]">
        <ImageRaw
          src={images.kidsplazaLogo}
          alt="KidsPlaza Logo"
          className="w-[22%] sm:w-[25%] h-auto object-contain"
        />
        <ImageRaw
          src={images.festivalLogo}
          alt="Festival Logo"
          className="w-[30%] object-contain"
        />
      </header>

      {/* Logo Vươn Concert */}
      <div className="absolute top-[3%] left-1/2 z-20 w-[35%] sm:w-[40%] -translate-x-1/2">
        <ImageRaw
          src={images.vuonConcertLogo}
          alt="Vuon Concert Logo"
          className="w-full h-auto object-contain"
        />
      </div>

      {/* Phần ca sĩ */}
      <div className="absolute top-[5%] left-0 right-0 z-10 h-[70%] w-full">
        <div className="relative h-full w-full">
          <ImageRaw
            src={images.singerBackground}
            alt="Singer Background"
            className="absolute !bottom-0 md:!bottom-[-25px] sm:bottom-[-35px] left-1/2 -translate-x-1/2 w-[260px] sm:w-[300px] rounded-[5%]"
          />
          <ImageRaw
            src={singer.imageUrl}
            alt={singer.name}
            className="absolute bottom-[28px] md:!bottom-[3px] lg:!bottom-[10px] !left-[52%] md:left-1/2 w-[180px] h-[204px] lg:!w-[220px] lg:h-[267px] -translate-x-1/2 object-contain"
          />
        </div>
      </div>

      {/* === PHẦN MỚI: TÊN CA SĨ VÀ THÔNG TIN SỰ KIỆN === */}
      <div className="absolute right-0 z-20 w-full flex flex-col items-center justify-center gap-y-1 text-center text-white
      bottom-[5%] left-[50%] -translate-x-1/2
      md:!bottom-[1%]
      lg:!bottom-[3%]
      ">
        <SingerNameText fontSize={variant === 'medium' ? 42 : 28} text={singer.name.toUpperCase()} />

        {/* Thông tin ngày và địa điểm */}
        <div className="flex items-center md:justify-start justify-center font-montserrat font-bold mx-auto">
          <div className="leading-tight text-[#1506b5]">
            <p className="text-[12px] md:text-[14px]">05.10</p>
            <p className="text-[12px] md:text-[16px]">2025</p>
          </div>
          <div className="md:h-[35px] h-[32px] w-[2px] bg-[#1506b5] mx-1"></div> {/* Dấu gạch dọc */}
          <div className="leading-tight text-[#1506b5] pt-2 md:pt-1">
            <p className="text-[8px] tracking-wide">CUNG THỂ THAO QUẦN NGỰA</p>
            <p className="text-[22px] tracking-wide">TP. HÀ NỘI</p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SingerCard;
